import React from 'react';

import './header.less';

const AppHeader = () => {
    return <div className="app-header">
        <div className="app-header-content-container">
            <div className="app-header-primary-logo">
                <div>Ocean Hatch Testing</div>
            </div>

            <div className="app-header-right-content">
                <div>Avatar Kutty</div>
            </div>
        </div>
    </div>;
};

export default AppHeader;
